<div class="modal-header">
  <h4 class="modal-title">{{ 'BROUTER_MAP.EXPORT.TITLE' | translate }}</h4>
  <button
    type="button"
    class="btn btn-circle btn-ghost element-cancel"
    [attr.aria-label]="'SHARED.CLOSE' | translate"
    (click)="closed.emit()"
  ></button>
</div>

<div class="modal-body">
  <div class="form-group">
    <label class="form-label" for="brouter-export-name">
      {{ 'BROUTER_MAP.EXPORT.TRACK_NAME' | translate }}
    </label>
    <input
      id="brouter-export-name"
      type="text"
      class="form-control"
      [ngModel]="trackname()"
      (ngModelChange)="trackname.set($event)"
    />
    @if (tracknameWasChanged()) {
      <small class="form-text text-warning">
        {{ 'BROUTER_MAP.EXPORT.NAME_SANITISED' | translate: { name: sanitisedTrackname() } }}
      </small>
    }
  </div>

  <fieldset class="form-group">
    <legend class="form-label">{{ 'BROUTER_MAP.EXPORT.FORMAT' | translate }}</legend>
    @for (format of formats; track format.value) {
      <label class="form-check form-check-inline">
        <input
          type="radio"
          class="form-check-input"
          name="brouter-export-format"
          [checked]="selectedFormat() === format.value"
          (change)="selectedFormat.set(format.value)"
        />
        <span class="form-check-label">{{ format.label }}</span>
      </label>
    }
  </fieldset>

  <label class="form-check">
    <input
      type="checkbox"
      class="form-check-input"
      [checked]="includeWaypoints()"
      (change)="includeWaypoints.set(!includeWaypoints())"
    />
    <span class="form-check-label">
      {{ 'BROUTER_MAP.EXPORT.INCLUDE_WAYPOINTS' | translate }}
    </span>
  </label>

  @if (hasBeeline()) {
    <p class="text-warning mt-3 mb-0">
      {{ 'BROUTER_MAP.EXPORT.BEELINE_WARNING' | translate }}
    </p>
  }
</div>

<div class="modal-footer">
  <button type="button" class="btn btn-secondary" (click)="closed.emit()">
    {{ 'SHARED.CANCEL' | translate }}
  </button>
  <button type="button" class="btn btn-primary" [disabled]="!canExport()" (click)="download()">
    {{ 'BROUTER_MAP.EXPORT.DOWNLOAD' | translate }}
  </button>
</div>
